<template>
  <div>
    <div v-if="list.length > 0">
      <div class="image_list">
        <div :key="item.url || item" v-for="item in imgList">
          <el-image
          v-if="item"
          style="width: 100px; height: 100px; margin-right: 10px"
          :src="item.url || item"
          :preview-src-list="previewList"
          fit="fill"></el-image>
        </div>
      </div>
      <div
        class="file_item"
        v-for="item in fileList"
        :key="item.url || item"
        :title="item.name || item"
        @click="handleDownload(item.url || item)"
      >
        <i class="el-icon-document"></i>
        {{ item.name || item }}
      </div>
    </div>
    <div v-else>暂无</div>
  </div>
</template>
<script>

export default {
  name: 'showImgAndFile',
  props: {
    list: {
      type: [String, Array], // 列表
      default: () => [],
    },
  },
  data() {
    return {
      imgList: [],
      fileList: [],
      imgType:
        '.jpg,.gif,.png,.jpeg,.bmp,.webp,.heic,.JPG,.GIF,.PNG,.JPEG,.BMP,.WEBP,.HEIC',
    }
  },
  computed: {
    // 图片列表
    previewList() {
      return this.imgList.map((item) => item.url)
    },
  },
  watch: {
    list: {
      handler(val) {
        this.getList(val)
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 判断返回的数据是不是json
    isJSON(str) {
      if (typeof str === 'string') {
        try {
          const obj = JSON.parse(str)
          if (typeof obj === 'object' && obj) {
            return true
          } else {
            return false
          }
        } catch (e) {
          return false
        }
      } else {
        return false
      }
    },
    // 获取图片和文件列表
    getList(allList) {
      if (allList) {
        const list = this.dealFile(allList)
        this.imgList = list.imgList
        console.log('this.imgList', this.imgList)
        this.fileList = list.fileList
      }
    },
    // 获取图片列表,文件列表
    dealFile(data) {
      // 只处理数组和字符串数据
      if (Array.isArray(data)) {
        return this.parseList(data)
      }
      if (typeof data === 'string') {
        // 如果是字符串数据判断是不是JSON字符串
        data = this.isJSON(data) ? JSON.parse(data) : data.split(',')
        return this.parseList(data)
      }
      return { imgList: [], fileList: [] }
    },
    // 下载图片
    handleDownload(url) {
      window.open(url)
    },
    // 处理数据
    parseList(list) {
      const imgList = []
      const fileList = []
      list.forEach((item) => {
        const path = item.url ? item.url.split('/') : item.split('/')
        const lastItem = path[path.length - 1]
        const lastDotIndex = lastItem.lastIndexOf('.')
        const suffix = lastItem.slice(lastDotIndex + 1).toLowerCase().split('?')[0]
        if (suffix) {
          if (this.imgType.includes(`.${suffix}`)) {
            imgList.push(item)
          } else {
            fileList.push(item)
          }
        }
      })
      return { imgList, fileList }
    },
  },
}
</script>
<style lang="scss" scoped>
.image_list {
  display: flex;
  div {
    margin-bottom: 10px;
  }
  :deep(.imgDiv) {
    margin-right: 10px;
  }
}
.file_item {
  width: 100%;
  color: #276bec;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 27px;
}
</style>
